// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3Qgn4","alertIcon":"ConfirmModal_alertIcon__3LRN_"};